module.exports = __webpack_public_path__ + "img/red-bullet.3fcd7859.png";